import React from 'react'
import SolicitationPresentation from "../../components/Solicitation/Presentation";
import SolicitationProvider from "../../components/Solicitation/Provider";

const SolicitationPage = () => {
    return (
        <SolicitationProvider>
            <SolicitationPresentation />
        </SolicitationProvider>
    )
}

export default SolicitationPage
